import { formatNumber } from '@/lib/utils';
import type { StatsOverview } from '@/types/api';

interface StatsGridProps {
  stats: StatsOverview | null;
  loading: boolean;
}

export function StatsGrid({ stats, loading }: StatsGridProps) {
  if (loading) {
    return (
      <section className="stats-grid grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="stat-card bg-bg-secondary border border-border rounded-xl p-5 text-center">
            <div className="stat-value text-3xl font-bold text-accent">-</div>
            <div className="stat-label text-text-secondary text-xs mt-1">加载中...</div>
          </div>
        ))}
      </section>
    );
  }

  return (
    <section className="stats-grid grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
      <div className="stat-card bg-bg-secondary border border-border rounded-xl p-5 text-center">
        <div className="stat-value text-3xl font-bold text-accent">
          {formatNumber(stats?.total_tweets || 0)}
        </div>
        <div className="stat-label text-text-secondary text-xs mt-1">总推文数</div>
      </div>
      <div className="stat-card bg-bg-secondary border border-border rounded-xl p-5 text-center">
        <div className="stat-value text-3xl font-bold text-accent">
          {formatNumber(stats?.likes_count || 0)}
        </div>
        <div className="stat-label text-text-secondary text-xs mt-1">点赞</div>
      </div>
      <div className="stat-card bg-bg-secondary border border-border rounded-xl p-5 text-center">
        <div className="stat-value text-3xl font-bold text-accent">
          {formatNumber(stats?.bookmarks_count || 0)}
        </div>
        <div className="stat-label text-text-secondary text-xs mt-1">收藏</div>
      </div>
      <div className="stat-card bg-bg-secondary border border-border rounded-xl p-5 text-center">
        <div className="stat-value text-3xl font-bold text-accent">
          {formatNumber(stats?.authors_count || 0)}
        </div>
        <div className="stat-label text-text-secondary text-xs mt-1">作者数</div>
      </div>
    </section>
  );
}
